var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.17995 14.8647L6.18005 14.8646L12.7366 8.30805L15.692 11.2634L9.13536 17.8199L9.13525 17.8201C9.02015 17.9352 8.86405 17.9999 8.70126 18C8.70119 18 8.70112 18 8.70104 18H6.61416C6.45127 18 6.29506 17.9353 6.17988 17.8201C6.06471 17.7049 6 17.5487 6 17.3858V15.299C6 15.2989 6 15.2988 6 15.2987C6.00009 15.1359 6.06481 14.9798 6.17995 14.8647ZM15.8649 5.17982C15.8649 5.17978 15.865 5.17975 15.865 5.17971C15.9801 5.06464 16.1363 5 16.2991 5C16.4619 5 16.618 5.06464 16.7332 5.17971C16.7332 5.17974 16.7333 5.17978 16.7333 5.17982L18.8202 7.26671C18.9353 7.38188 19 7.53806 19 7.70091C19 7.86376 18.9353 8.01995 18.8202 8.13512L18.2474 8.70793L15.2921 5.75263L15.8649 5.17982Z",
    stroke: "#eb2426",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5c77455c24272b5b4228a8b5d1b61f90.svg";
export { ForwardRef as ReactComponent };